import axiosInstance from '../config/axiosInstance';
import { API_ENDPOINTS } from '../constants/apiEndpoints';

export const getAdminRoles = async (params = {}) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.ROLES.GET_ALL, { params });
    return response.data;
};
